<script setup>
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from '@/shadcn/components/ui/tooltip'

const props = defineProps({
  title: String,
  side: {
    type: String,
    default: 'top',
    validator: (value) => ['left', 'right', 'bottom', 'top'].includes(value)
  }
});
</script>

<template>
  <TooltipProvider v-if="props.title || $slots.title">
    <Tooltip>
      <TooltipTrigger v-bind="$attrs">
        <slot></slot>
      </TooltipTrigger>
      <TooltipContent :side="props.side">
        <slot name="title">{{ props.title }}</slot>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
